import { render, staticRenderFns } from "./PlanName.vue?vue&type=template&id=37425032"
import script from "./PlanName.vue?vue&type=script&lang=js"
export * from "./PlanName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports